module.exports = __webpack_public_path__ + "img/base_activites_via_ferrata.024540b9.svg";